export default {"src":"/_next/static/media/icon_footer_more.bac8db3d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};